
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum",
      function () {
        return require("private-next-pages/forum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum"])
      });
    }
  